import PropertyDetailsAddress from '../property-details-address/property-details-address.vue';
import PropertyDetailsTenant from '../property-details-tenant/property-details-tenant.vue';

export default {
  name: 'property-details',
  components: {
    PropertyDetailsAddress,
    PropertyDetailsTenant,
  },
  data() {
    return {
      isAddressValid: false,
      isTenantValid: false,
    };
  },
  computed: {
    disableNext() {
      return !this.isValid();
    },
  },
  methods: {
    addressValid(value) {
      this.isAddressValid = value;
    },
    tenantValid(value) {
      this.isTenantValid = value;
    },
    nextStep() {
      this.$emit('nextStep');
    },
    isValid() {
      return this.isAddressValid && this.isTenantValid;
    },
  },
};
